import { Typography } from 'lighthouse';

export const SidebarTitle = ({ title }: { title: string }) => (
    <div className='flex items-center justify-between'>
        <div className='flex items-center gap-2'>
            <div className='flex h-3 w-3 items-center justify-center rounded-full bg-primary/10'>
                <span className='block h-1 w-1 rounded-full bg-primary/40' />
            </div>
            <Typography variant='subtitle1' className='text-sm font-bold text-blackMediumEmphasis'>
                {title}
            </Typography>
        </div>
    </div>
);
